import { createAuth0Strategy } from './auth0-strategy.js';
import { createMockedAuthStrategy } from './mocked-auth-strategy.js';
var createSeekAuthStrategy = function (options) {
    switch (options.forceStrategy) {
        case 'AUTH0':
            return createAuth0Strategy(options);
        case 'MOCKED':
            return createMockedAuthStrategy(options);
    }
    return createAuth0Strategy(options);
};
export default createSeekAuthStrategy;
//# sourceMappingURL=seek-auth-strategy.js.map